module.exports = __webpack_public_path__ + "img/logo-zug.a259f81b.png";